import { reactive } from '../../js/reactive';
import { selectors } from './config';
import { data } from './data';
import { ajax } from './ajax';
import { renderItems } from './renderItems';
import { renderTotalBlock } from './renderTotalBlock';
import './styles/cartTabForSidebar.scss';
import { dlCartOpenEvent } from '../../events/cart/dl.cart.open.event';
const vNode = window.vNode;
let tabHead;
let tabBody;
const renderHead = () => {
    let oldHead;
    reactive.watch(() => {
        const newHead = vNode.create('p', { class: 'ss__head_item_title' }, [
            vNode.create('s-svg', { 'data-icon': '#icon__header_cart' }),
            vNode.create('b', {}, ['SHOPPING CART']),
            vNode.create('span', {}, [`(${data.itemCount})`])
        ]);
        vNode.patch(oldHead, newHead, tabHead);
        oldHead = newHead;
    });
};
const renderBody = () => {
    renderItems(tabBody);
    renderTotalBlock(tabBody);
};
const init = (openFunc) => {
    tabHead = document.createElement('button');
    tabBody = document.createElement('div');
    tabHead.dataset.tabKey = tabBody.dataset.tabKey = 'ss_cart';
    tabHead.setAttribute('aria-label', 'Shopping cart tab');
    tabHead.classList.add('btn:cleared');
    if (window.location.pathname.includes('cart')) {
        tabHead.hidden = true;
    }
    renderHead();
    renderBody();
    document.body.addEventListener('click', (event) => {
        if (event.target === null)
            return;
        const target = event.target;
        const open = target.closest(selectors.open);
        if (open !== null) {
            openFunc('ss_cart');
        }
    });
    document.addEventListener('addToCart', (event) => {
        void ajax.getCart(event.detail.itemData);
    });
    reactive.watch(() => {
        document.querySelectorAll(selectors.indicators).forEach((indicator) => {
            indicator.hidden = !data.itemCount;
            indicator.innerHTML = String(data.itemCount);
        });
    });
    void ajax.getCart().then(() => {
        window.location.pathname.includes('/cart') && dlCartOpenEvent();
    });
    window.cart = {
        getData() {
            return {
                items: data.items,
                total: data.totalPrice
            };
        },
        on(key, fun) {
            switch (key) {
                case 'data':
                    reactive.watch(() => {
                        fun({
                            items: data.items,
                            total: data.totalPrice
                        });
                    });
                    break;
                case 'total':
                    reactive.watch(() => {
                        fun({
                            total: data.totalPrice
                        });
                    });
            }
        }
    };
    return {
        head: tabHead,
        body: tabBody,
        tabName: 'cart',
        key: 'ss_cart'
    };
};
export const cartTabForSidebar = init;
